module.exports = __webpack_public_path__ + "static/img/pic_rjyf_rjys_ry100@2x.3cf6d425.png";